import { render, staticRenderFns } from "./HealthScene.vue?vue&type=template&id=52886657"
import script from "./HealthScene.vue?vue&type=script&lang=js"
export * from "./HealthScene.vue?vue&type=script&lang=js"
import style0 from "./HealthScene.vue?vue&type=style&index=0&id=52886657&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports